// extracted by mini-css-extract-plugin
export var contained = "icon-module--contained--49851";
export var containerIcon = "icon-module--containerIcon--3ab54";
export var containerPointer = "icon-module--containerPointer--12cf8";
export var icon = "icon-module--icon--d1653";